import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Button } from "@babackapp/ui/components/button";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { SettingsFormHeader } from "@babackapp/react-hook-forms-components/form-page";
import { Separator } from "@radix-ui/react-select";
import AddReturnReasonDialog from "./add-return-reason-dialog.tsx";
import ReturnReasonListItem from "./return-reason-list-item.tsx";
import useTranslation from "@babackapp/translations/use-translation";
import VerticalDragAndDrop from "@/components-legacy/verticalDragAndDrop";
import type { ShopReasonsDto } from "@babackapp/private-api-client/types";
import { useParams } from "react-router-dom";
import useUpdateShopReasons from "@babackapp/private-api-client/client/use-update-shop-reasons";
import { useEffect, useState } from "react";

export default function ReturnReasonList() {
  const t = useTranslation();
  const shopId = useParams<{ shopId: string }>().shopId as string;
  const [activeReasons, setActiveReasons] = useState<ShopReasonsDto[]>([]);

  const { data: shop } = useCurrentShopSuspense();

  useEffect(() => {
    setActiveReasons(shop.reasons.filter((reason) => reason.active));
  }, [shop]);

  const { mutate: updateReasons } = useUpdateShopReasons(shopId);

  const handleReasonsReorder = (reorderedReasons: ShopReasonsDto[]) => {
    const inactiveReasons = shop.reasons.filter((reason) => !reason.active);
    const updatedReasons = [...reorderedReasons, ...inactiveReasons];
    setActiveReasons(reorderedReasons);
    updateReasons(updatedReasons);
  };

  return (
    <Card>
      <CardContent className="py-8">
        <div className="flex items-center justify-between">
          <SettingsFormHeader
            title={t("settings.reasons.title")}
            description={t("settings.reasons.subtitle")}
          />
          <AddReturnReasonDialog>
            <Button>{t("misc.add")}</Button>
          </AddReturnReasonDialog>
          <Separator className="mt-4" />
        </div>
        <div className="flex flex-col mt-2">
          <VerticalDragAndDrop<ShopReasonsDto>
            items={activeReasons}
            onChange={handleReasonsReorder}
            itemRenderer={(reason) => <ReturnReasonListItem reason={reason} />}
          />
        </div>
      </CardContent>
    </Card>
  );
}
